import { Link } from "react-router-dom";
import ArticleCard from "@/components/feature/ArticleCard";
import { articles } from "@/mocks/data";

export default function LatestArticles() {
  const latest = [...articles].sort((a, b) => (a.date < b.date ? 1 : -1)).slice(0, 8);
  return (
    <section className="mx-auto w-full max-w-7xl px-4 py-10 md:px-6 md:py-14" aria-label="最新书评">
      <div className="flex items-end justify-between">
        <div>
          <h2 className="font-heading text-2xl font-black text-foreground-950 md:text-3xl">最新书评 · 同好讨论</h2>
          <p className="mt-2 text-sm text-foreground-600">深度解析、安利推荐、追更吐槽，一起来聊</p>
        </div>
        <Link
          to="/category/xuanhuan"
          className="hidden items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-700 hover:text-primary-800 sm:flex"
        >
          全部书评 <i className="ri-arrow-right-line" aria-hidden="true"></i>
        </Link>
      </div>

      <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {latest.map((article) => (
          <ArticleCard key={article.id} article={article} />
        ))}
      </div>
    </section>
  );
}